import { getClientRouteOptions, RouteOptions } from "helpers/map";
import React, { useState } from "react";
import { createRoute } from "sources/map";

export const getBidRouteSegmentKeys = (bidPoints = []) =>
    bidPoints.reduce((acc, item, index) => {
        if (bidPoints[index + 1]) {
            acc.push({
                mapObjectFrom: item.geozone,
                mapObjectTo: bidPoints[index + 1].geozone,
                order: index,
            });
        }
        return acc;
    }, []);

export const applyBidRoute = ({ bidId, bidPoints, settings }) =>
    createRoute({
        ...settings,
        routeOptions: getClientRouteOptions(settings.routeOptions),
        bidId: Number(bidId),
        segmentKeys: getBidRouteSegmentKeys(bidPoints),
        routeIndex: 0,
    });

const UpdateRoute = (props) => {
    const [loading, setLoading] = useState(false);
    const [settings, setSettings] = useState({
        routeOptions: getClientRouteOptions(props.routeOptions || props.defaultRouteOptions),
    });
    const saveRoute = () => {
        setLoading(true);
        applyBidRoute({ settings, bidId: props.bidId, bidPoints: props.bidPoints }).then((res) => {
            if (res) {
                props.refreshBid();
                props.back();
            }
            setLoading(false);
        });
    };
    return (
        <div className={loading ? "loading" : ""}>
            <RouteOptions
                defaultRouteOptions={props.defaultRouteOptions}
                routeOptions={settings.routeOptions}
                updateSettings={setSettings}
                modal={props.modal}
            />
            <div className="d-flex justify-content-between">
                <div className="btn btn-secondary btn-sm" onClick={() => props.back()}>
                    Отменить
                </div>
                <div className="btn btn-brand btn-sm" onClick={saveRoute}>
                    Сохранить
                </div>
            </div>
        </div>
    );
};

export default UpdateRoute;
